import React from 'react';
import { XIcon } from 'lucide-react';
type PanelShellProps = {
  title: string;
  badge?: React.ReactNode;
  onClose: () => void;
  footer?: React.ReactNode;
  children: React.ReactNode;
};
export function PanelShell({
  title,
  badge,
  onClose,
  footer,
  children
}: PanelShellProps) {
  return <section aria-label={`${title} panel`} className="flex max-h-full w-[300px] flex-col overflow-hidden rounded-[7px] bg-white shadow-[0_3px_12px_rgba(20,28,38,0.14)] ring-1 ring-black/[0.06]" data-id="element-874" data-mp="3b83zyulexq7m">
      
      <header className="flex h-[32px] shrink-0 items-center justify-between border-b border-pf-line bg-white px-2" data-id="element-875" data-mp="7qviwcyieudy">
        <div className="flex items-center gap-2" data-id="element-876" data-mp="3q5ek0sc4g4ey">
          <h2 className="text-[15px] font-bold text-pf-ink" data-id="element-877" data-mp="3u79izq6ky5pk">{title}</h2>
          {badge}
        </div>
        <button type="button" aria-label={`Close ${title}`} onClick={onClose} className="flex h-[20px] w-[20px] items-center justify-center rounded text-pf-ink transition-colors duration-150 hover:bg-pf-panel" data-id="element-878" data-mp="lry7awcz8gs1">
          
          <XIcon className="h-[14px] w-[14px]" strokeWidth={2.6} data-id="element-879" data-mp="pzvqukgiz68r" />
        </button>
      </header>
      <div className="min-h-0 flex-1 overflow-y-auto bg-pf-panel px-2 pb-2" data-id="element-880" data-mp="l4opvken4fnj">{children}</div>
      {footer && <footer className="flex shrink-0 gap-[8px] border-t border-pf-line bg-[#f8f8f9] px-2 py-[8px]" data-id="element-881" data-mp="ztup38dha5vf">{footer}</footer>}
    </section>;
}